import { render } from "./HeaderShowCol.vue?vue&type=template&id=1718dbd2&scoped=true"
import script from "./HeaderShowCol.vue?vue&type=script&lang=js"
export * from "./HeaderShowCol.vue?vue&type=script&lang=js"

import "./HeaderShowCol.vue?vue&type=style&index=0&id=1718dbd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1718dbd2"

export default script